import React from 'react';
import { Content, Row, Col, Title, Button, Pagination } from 'components';
import { Empty, DatePicker, Spin } from 'antd';
import { CollapseItem } from 'routes/main.routes/ProductDetail/components';
import { SideMenu } from 'routes/main.routes/Mypage/components';
import more from 'assets/more.svg';
import { csMenu } from '../csMenu';
import Formatter from 'utils/Formatter';
import MessageAlert from 'utils';
import dayjs from 'dayjs';

const PERIOD = [
  {
    label: '1개월',
    value: 1,
    key: 'month',
  },
  {
    label: '3개월',
    value: 3,
    key: 'month',
  },
  {
    label: '6개월',
    value: 6,
    key: 'month',
  },
  {
    label: '1년',
    value: 1,
    key: 'year',
  },
];

const DATE_FORMAT = 'YYYY/MM/DD';
const PAGE_COUNT = 5;
const PAGE_SIZE = 5;

const HelpInquirePresenter = (props) => {
  /* ===== Props ===== */
  const { user, navigate, inquiries, isLoading, setIsLoading, screenSize } =
    props;

  /* ===== Vaiables ===== */
  const styles = {
    titleLayout: {
      display: 'flex',
      gap: 8,
      alignItems: 'center',
      justifyContent: 'end',
      paddingBottom: 32,
      borderBottom: '2px solid var(--black-color)',
    },
    tabContainer: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 32,
      borderBottom: '2px solid var(--black-color)',
    },
    tab: {
      width: 160,
      height: 66,
      lineHeight: '66px',
      textAlign: 'center',
      cursor: 'pointer',
      fontSize: 16,
      border: '1px solid gray',
      backgroundColor: 'transparent',
      color: 'gray',
    },
    activeTab: {
      fontWeight: 'bold',
      backgroundColor: 'black',
      color: 'white',
      border: '2px solid black',
    },
    emptyState: {
      textAlign: 'center',
      padding: 20,
      fontSize: 16,
      color: 'gray',
    },
    // paginationButton: {
    //   color: 'var(--black-color)',
    //   width: 28,
    //   height: 28,
    //   display: 'flex',
    //   justifyContent: 'center',
    //   alignItems: 'center',
    // },
    buttonGroup: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
    },
    button: {
      width: '25%',
      borderRadius: '0',
      border: '1px solid var(--light-gray-color)',
      backgroundColor: '#fff',
      color: 'var(--light-gray-color)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 700,
      fontSize: screenSize >= 768 ? 16 : 14,
      cursor: 'pointer',
    },
    activeButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
    },

    title: {
      fontSize: 16,
      color: 'var(--black-color)',
      lineHeight: '180%',
    },

    swiperButton: {
      width: 20,
      height: 20,
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#DDDDDD',
      fontSize: 12,
    },

    infoText: {
      display: 'flex',
      alignItems: 'stretch',
      fontSize: 16,
      fontWeight: 400,
      lineHeight: '180%',
      color: 'var(--black-color)',
    },

    paginationButton: {
      border: '1px solid var(--black-color)',
      color: 'var(--black-color)',
      width: 48,
      height: 48,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
    },

    bullet: {
      width: 60,
      display: 'inline-block',
      cursor: 'pointer',
    },

    select: {
      width: '100%',
      height: 48,
      fontSize: 16,
    },

    amountButton: {
      width: 28,
      height: 28,
      borderRadius: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderColor: 'var(--light-gray-color)',
    },
    optionWrap: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    optionContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    option: {
      flex: 1,
    },
    optionTitle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#999999',
    },

    shareButton: {
      border: 'none',
      background: 'none',
      cursor: 'pointer',
      fontSize: 20,
      color: '#999999',
    },
  };

  /* ===== State ===== */
  // 문의 내역
  const [inquiryList, setInquiryList] = React.useState([]);
  // Period Date
  const [selected, setSelected] = React.useState(0);
  // Period Range
  const [period, setPeriod] = React.useState([]);
  const [currentPage, setCurrentPage] = React.useState(1); // 현재 페이지

  /* ===== Function ===== */
  /**
   * 페이징
   * --
   * @param {number} page
   */
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  /**
   * 검색기간 설정
   * --
   */
  const handleDateChange = (date, key) => {
    if (selected === date) {
      setSelected(0);
      setPeriod([]);
    } else {
      const start = dayjs().subtract(date, key);

      setSelected(`${date}-${key}`);
      setPeriod([start, dayjs().endOf('day')]);
    }
  };

  /**
   * 기간 검색
   * --
   */
  const handlePeriodSearch = () => {
    const [start, end] = period;

    if (!start || !end) {
      return MessageAlert.info('검색 기간을 선택해주세요!');
    }
    setIsLoading(true);

    const startDate = dayjs(start).startOf('day').unix();
    const endDate = dayjs(end).endOf('day').unix();

    const filtered = inquiries
      .filter((iq) => iq.create >= startDate && iq.create <= endDate)
      .sort((a, b) => b.create - a.create);

    setTimeout(() => {
      setInquiryList(filtered);
      setIsLoading(false);
    }, 500);
  };

  /* ===== Hooks ===== */
  /**
   * 탭별 문의 목록 정제
   * --
   */
  React.useEffect(() => {
    const filtered = inquiries
      .slice()
      .sort((a, b) => b.created_at - a.created_at);

    setInquiryList(filtered);
  }, [inquiries]);

  return (
    <React.Fragment>
      <Spin spinning={isLoading}>
        <Content
          maxWidth={1820}
          padding={screenSize >= 768 ? '120px 0px' : '80px 0'}
        >
          <Row gutter={25}>
            <Col x={0} md={2}></Col>
            <Col x={0} md={4}>
              <SideMenu menu={csMenu} title="고객센터" />
            </Col>
            <Col x={24} md={16}>
              <Content
                maxWidth={'100%'}
                padding={screenSize >= 768 ? '0 0 0 95px' : '0'}
              >
                {/* 주문내역 */}
                <Content maxWidth={'100%'} padding={0}>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Title
                      style={{
                        fontSize:
                          screenSize >= 768 ? 32 : screenSize >= 500 ? 28 : 20,
                        fontWeight: 700,
                      }}
                    >
                      1:1 문의
                    </Title>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '32px 0',
                        marginBottom: 30,
                        borderBottom: '1px solid #ddd',
                        flexDirection: screenSize >= 768 ? 'unset' : 'column',
                        gap: screenSize >= 768 ? 'unset' : '10px',
                      }}
                    >
                      <div
                        style={{
                          display: 'flex',
                          width: screenSize >= 768 ? '51.44%' : '100%',
                          height: 48,
                        }}
                      >
                        <div style={styles.buttonGroup}>
                          {PERIOD.map((period) => (
                            <button
                              key={`${period.value}-${period.key}-${period.label}`}
                              style={{
                                ...styles.button,
                                ...(selected === `${period.value}-${period.key}`
                                  ? styles.activeButton
                                  : {}),
                              }}
                              onClick={() => {
                                handleDateChange(period.value, period.key);
                                setCurrentPage(1); // 기간 변경 시 페이지를 초기화
                              }}
                            >
                              {period.label}
                            </button>
                          ))}
                        </div>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          width: screenSize >= 768 ? '46.3%' : '100%',
                        }}
                      >
                        <DatePicker.RangePicker
                          style={{
                            width: '64%',
                            height: 48,
                            border: '1px solid var(--light-gray-color)',
                          }}
                          value={[
                            period?.[0] ? dayjs(period?.[0], DATE_FORMAT) : '',
                            period?.[1] ? dayjs(period?.[1], DATE_FORMAT) : '',
                          ]}
                          format={DATE_FORMAT}
                          placeholder={['시작일', '종료일']}
                          minDate={dayjs().subtract(365, 'day')}
                          maxDate={dayjs()}
                          onChange={(_, dateString) => setPeriod(dateString)}
                        />
                        <Button
                          style={{
                            width: '31.12%',
                            borderRadius: '0',
                            fontWeight: 700,
                            fontSize: screenSize >= 768 ? 16 : 14,
                            backgroundColor: 'var(--white-color)',
                            color: 'var(--black-color)',
                            border: '1px solid var(--black-color)',
                          }}
                          onClick={() => handlePeriodSearch()}
                        >
                          조회
                        </Button>
                      </div>
                    </div>
                  </div>
                </Content>
                <div style={{ ...styles.titleLayout }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate('/cs/inquireform')}
                  >
                    <Title
                      style={{
                        ...styles.title,
                        cursor: 'pointer',
                        fontSize: screenSize >= 768 ? 16 : 14,
                      }}
                    >
                      문의하기
                    </Title>
                    <img
                      src={more}
                      alt="more icon"
                      style={{ cursor: 'pointer' }}
                    />
                  </div>
                </div>
                {/* SECTION: 상품문의 */}
                <div>
                  <div>
                    {inquiryList.length ? (
                      inquiryList
                        .slice(
                          (currentPage - 1) * PAGE_COUNT,
                          currentPage * PAGE_COUNT
                        )
                        .map((_item, _index) => (
                          <CollapseItem
                            title={_item.title}
                            content={_item.content}
                            userName={user?.user_name}
                            answer={_item.answer}
                            answerName={_item.answerName}
                            update={Formatter.unixToDate(
                              _item.update,
                              'YYYY.MM.DD'
                            )}
                            create={Formatter.unixToDate(
                              _item.create,
                              'YYYY.MM.DD'
                            )}
                            status={_item.status}
                            // secret={_item.secret}
                            showContent={true}
                            files={_item.files}
                          />
                        ))
                    ) : (
                      <div style={{ padding: '28px 0px' }}>
                        <Empty description={'등록된 문의사항이 없습니다.'} />
                      </div>
                    )}
                  </div>

                  <div style={{ marginTop: 100 }}>
                    <Pagination
                      total={inquiryList.length} //inquiries.length
                      pageSize={PAGE_SIZE}
                      showPage={5}
                      current={currentPage}
                      buttonStyle={{
                        fontSize: 16,
                        fontWeight: 700,
                        color: '#999999',
                        background: 'none',
                        width: 28,
                        height: 28,
                      }}
                      isButton={true}
                      activeStyle={{
                        color: `var(--black-color) !important`,
                        borderBottom: '2px solid #111111',
                      }}
                      hoverStyle={{
                        color: `var(--black-color) !important`,
                      }}
                      navStyle={{
                        border: '1px solid var(--black-color)',
                      }}
                      isLatestButton={true}
                      onChange={handlePageChange}
                    />
                  </div>
                </div>
                {/* 상품문의 끝 */}
              </Content>
            </Col>
            <Col x={0} md={2}></Col>
          </Row>
        </Content>
      </Spin>
    </React.Fragment>
  );
};

export default HelpInquirePresenter;
